type TBuildHandleIdProps = {
  type: 'output' | 'input' | 'output-link';
  nodeId: string;
  handleType: string;
  suffix?: string;
};

export function buildHandleId({
  type,
  nodeId,
  handleType,
  suffix,
}: TBuildHandleIdProps) {
  return `${handleType}-${type}-${nodeId}${suffix ? `-${suffix}` : ''}`;
}
